// src/app/shared/services/script-loader.service.ts
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ScriptLoaderService {
  private loadedScripts = new Set<string>();

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loadedScripts.has(src)) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.loadedScripts.add(src);
        resolve();
      };
      script.onerror = () => reject(new Error(`Script load error for: ${src}`));

      document.head.appendChild(script);
    });
  }

  loadInlineScript(code: string): Promise<void> {
    return new Promise((resolve) => {
      const marker = "__INLINE_SCRIPT_DONE__";
      const wrappedCode = `
        (async function() {
          ${code}
          window.dispatchEvent(new Event('${marker}'));
        })();
      `;
      const script = document.createElement("script");
      script.text = wrappedCode;
      document.head.appendChild(script);

      window.addEventListener(marker, () => resolve(), { once: true });
    });
  }
}
